import Header from '@/components/template/Header'
import Logo from '@/components/template/Logo'
import MobileNav from '@/components/template/MobileNav'
import Notification from '@/components/template/Notification'
import LayoutBase from '@/components//template/LayoutBase'
import useResponsive from '@/utils/hooks/useResponsive'
import { LAYOUT_PLAIN_TOP_BAR } from '@/constants/theme.constant'
import type { CommonProps } from '@/@types/common'
import UserProfileDropdown from '@/components//template/UserProfileDropdown'

interface PlainTopbarProps extends CommonProps {
    hideUserProfile?: boolean
}

const PlainTopbar = ({ children, hideUserProfile }: PlainTopbarProps) => {
    const { larger, smaller } = useResponsive()

    return (
        <LayoutBase
            type={LAYOUT_PLAIN_TOP_BAR}
            className="app-layout-top-bar-classic plain-top-bar"
        >
            {/* <div className="flex flex-auto min-w-0">
                <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full"> */}
                    <Header
                        container
                        className="shadow dark:shadow-2xl"
                        headerStart={
                            <>
                                {/* {smaller.lg && <MobileNav />} */}
                                <Logo />
                            </>
                        }
                        // headerMiddle={<>{larger.lg && <HorizontalNav />}</>}
                        headerEnd={
                            <>
                                {/* <Notification /> */}
                                {!hideUserProfile && (
                                    <UserProfileDropdown hoverable={false} />
                                )}
                            </>
                        }
                    />
                    {children}
                {/* </div>
            </div> */}
        </LayoutBase>
    )
}

export default PlainTopbar
